/**
 * Warning banner for a previously signed/submitted note that was reopened:
 * its signatures are inactive until the note is re-signed. Rendered by
 * NoteChatView while completion_status === 'reviewing' and the note carries
 * both a last_reopened stamp and prior signature entries.
 */

import React from 'react';
import { Alert } from '@mui/material';
import type { NoteReopenInfo } from '@store/generated/notes';
import { formatDate } from '@utils/utils';

export interface NoteReopenedBannerProps {
  lastReopened: NoteReopenInfo;
}

export const NoteReopenedBanner: React.FC<NoteReopenedBannerProps> = ({ lastReopened }) => (
  <Alert severity="warning" sx={{ mx: 2, mt: 1 }}>
    This note was reopened by {lastReopened.name} on{' '}
    {formatDate(lastReopened.reopened_at, 'both')}. Its previous signatures are no longer
    active — sign the note again to resubmit it.
  </Alert>
);
